export default "__VITE_ASSET__0edd576f__"